import React from 'react';
import { Dialog } from '../ui/Dialog';
import { TradeConfiguration } from './TradeConfiguration';

interface TradeConfigurationDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TradeConfigurationDialog({ isOpen, onClose }: TradeConfigurationDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Configure New Trade"
      className="max-w-xs sm:max-w-md md:max-w-lg lg:max-w-4xl"
    >
      <TradeConfiguration />
    </Dialog>
  );
}

export default TradeConfigurationDialog;
